import { useQuery, QueryResult } from '@apollo/client';
import { useRouter } from 'next/router';
// Hocks
import { useRedirectOnError } from 'hooks';
// Api
import { GET_STORE_MERCH_PRODUCT } from 'api/merch/queries';
// Types
import {
  GetStoreMerchProduct,
  GetStoreMerchProductVariables,
} from 'api/merch/types/GetStoreMerchProduct';

export const useGetMerchProduct = (): QueryResult<
  GetStoreMerchProduct,
  GetStoreMerchProductVariables
> => {
  const router = useRouter();
  const { athleteSlug, productSlug } = router.query;
  const cleanProductSlug = (productSlug as string)?.split('?')[0];

  const data = useQuery<GetStoreMerchProduct, GetStoreMerchProductVariables>(
    GET_STORE_MERCH_PRODUCT,
    {
      variables: {
        input: {
          slug: cleanProductSlug,
          storeSlug: athleteSlug as string,
        },
      },
      skip: !cleanProductSlug || !athleteSlug,
    }
  );

  useRedirectOnError({
    error: data.error,
    redirectTo: `/${athleteSlug}/merch`,
  });

  return data;
};
